/** Build-time configuration. `VITE_VIKO_MOCK=1` builds the self-contained demo/e2e app. */
export const MOCK = import.meta.env.VITE_VIKO_MOCK === '1'

/** Origin of the control plane. Same-origin by default (the Worker serves these assets). */
export const API_ORIGIN: string = import.meta.env.VITE_VIKO_API_ORIGIN ?? ''

export const SOFTWARE_VERSION = 'web/0.1.0'
